import { withJsonFormsMultiEnumProps } from "@jsonforms/react";
import { Dropdown } from "pepsico-ds";
import { useEffect, useMemo, useState } from "react";

const MultipleSelectComponent = ({
  handleChange,
  label,
  path,
  required,
  schema,
  uischema,
  visible,
  enabled,
  data,
}) => {
  const [selected, setSelected] = useState(
    uischema?.selection === "single" ? "" : []
  );
  const [hasLoadedData, setHasLoadedData] = useState(false);
  const options = useMemo(
    () => schema?.items?.options || schema?.options || [],
    [schema]
  );

  useEffect(() => {
    if (data && options.length > 0 && !hasLoadedData) {
      const selectedOptions = options.filter((option) =>
        Array.isArray(data) ? data.includes(option.id) : data === option.id
      );
      setSelected(selectedOptions);
      setHasLoadedData(true);
    }
  }, [data, options, hasLoadedData]);

  const formatData = (data) =>
    data && data.length > 0 ? data.map((item) => item.id) : [];

  const handleSelectValue = (val) => {
    setSelected(val);

    handleChange(path, formatData(val));
  };

  return visible ? (
    <div className="multiple-select-wrap peacock-dropdown-show-label">
      <Dropdown
        label={label}
        childList={options}
        selection={uischema?.selection === "single" ? "single" : "multiple"}
        isRequired={required}
        disabled={!enabled}
        selectedValue={selected}
        placeholder={uischema?.placeholder}
        setSelectedValue={handleSelectValue}
      />
    </div>
  ) : null;
};

export const MultipleSelectControl = withJsonFormsMultiEnumProps(
  MultipleSelectComponent
);
